import React from 'react';
import './DashboardPage.css';

const DashboardPage: React.FC = () => {
  return (
    <div className="dashboard-page" data-testid="dashboard-page">
      <div className="dashboard-page__header">
        <h1 className="dashboard-page__title">Дашборд</h1>
      </div>
      <div className="dashboard-page__content">
        <div className="dashboard-page__placeholder">
          <span className="dashboard-page__placeholder-icon">📊</span>
          <p className="dashboard-page__placeholder-text">
            Здесь будет отображаться сводная информация по платформе: статистика, графики и ключевые метрики.
          </p>
        </div>
      </div>
    </div>
  );
};

DashboardPage.displayName = 'DashboardPage';

export default DashboardPage;
